import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { StyledBannerIconImage } from "./styles";

type BannerIconProps = {
    iconName?: IconName;
    iconImagePath?: string;
};

/**
 * `SWReactIcons` is deprecated, but its replacement `DynamicIcon` takes `IconNameV2`, and
 * `signalTypeIconMap` still holds v1 names with no v2 counterpart (e.g. `sidebar3-search-apps`).
 * Keeping the call here confines it to one site until that map is migrated.
 */
const BannerIcon = ({ iconName, iconImagePath }: BannerIconProps) => {
    if (iconName) {
        return (
            <SWReactIcons
                iconName={iconName}
                size="24px"
                iconColor={colorsPalettes.indigo[300]}
            />
        );
    }

    if (iconImagePath) {
        return <StyledBannerIconImage src={iconImagePath} />;
    }

    return null;
};

export default BannerIcon;
